export default __webpack_public_path__ + "static/media/magahi_lang.4a938999.png";